function initGoogleMap() {

    function forEach(array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    }

    var maps = document.getElementsByClassName('gmap');
      
    function startMap(map) {

        var data = JSON.parse(map.getAttribute('data-map')), 
            latitude = Number(data[0]),
            longitude = Number(data[1]),
            latLng = new google.maps.LatLng(latitude, longitude),
            mapZoom = 18

        var mapInstance = new google.maps.Map(map, {
            zoom: mapZoom,
            center: latLng,
            mapTypeId: 'terrain',
            disableDefaultUI: true
        });

        var marker = new google.maps.Marker({
            position: latLng,
            map: mapInstance,
        });

    }

    if (maps) {
        forEach(maps, function (index, map) {
            startMap(map);
        });
    }

}